import axios from '../../axios/index.js'
import store from '../../../store/store.js'


export default {
    getCurrentScheduleByDate(currentDate, userId = '') {
       return axios.get('/api/timekeeping/scheduledate', { params : { 
            scheduleDate: currentDate,
            userId : userId }
        })
    },
    getAllSegment(sortBy, sortOrder, pageNumber, pageSize) {
        return axios.get('/api/timekeeping', { params : {
            sortBy: sortBy,
            sortOrder: sortOrder,
            pageNumber: pageNumber,
            pageSize: pageSize
        }})
    },
    getLatestSegments(scheduleId, segmentTypeId) {
        return axios.get('/api/timekeeping/segmenttypeId', { params : {
            scheduleId: scheduleId,
            segmentTypeId: segmentTypeId
        }})
    }
}